/**
 * @generated SignedSource<<934ad5fa1a5e4e950570c62d0b16220f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFavoritesItem_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "useFavoritesItem_item";
};
export type useFavoritesItem_item$key = {
  readonly " $data"?: useFavoritesItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFavoritesItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFavoritesItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "0bff09a3cea77bbd89f1c11f683989bf";

export default node;
